import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isSafeHtml } from '@utils/html-sanitizer.util';

@Pipe({ name: 'sanitizerHtml' })
export class SanitizerHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(v: string): SafeHtml {
    if (isSafeHtml(v)) {
      return this.sanitizer.bypassSecurityTrustHtml(v); // NOSONAR - S6268: HTML validado por isSafeHtml() antes do bypass
    }
    return '';
  }
}
